import { gql } from '@apollo/client';

export const CREATE_ADDRESS_COORDINATE_FEEDBACK = gql`
  mutation CreateAddressCoordinateFeedback($input: CreateAddressCoordinateFeedbackInput!) {
    createAddressCoordinateFeedback(input: $input) {
      success
      code
      message
    }
  }
`;

export interface CreateAddressCoordinateFeedbackInput {
  orderAddressId: number;
  originalLatitude?: number | null;
  originalLongitude?: number | null;
  feedbackLatitude: number;
  feedbackLongitude: number;
  requestId?: string | null;
  trackingNumber?: string | null;
  driverLatitude?: number | null;
  driverLongitude?: number | null;
  primaryTypeCode?: string | null;
  secondaryTypeCode?: string | null;
}

export interface CreateAddressCoordinateFeedbackResponse {
  createAddressCoordinateFeedback: {
    success: boolean;
    code: string;
    message: string | null;
  };
}

